module.exports = __webpack_public_path__ + "static/media/bannerImg.d9cce6c0.png";